import React, { useState, useEffect } from "react";
import Form, { GroupItem } from "devextreme-react/form";
import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  Lookup,
} from "devextreme-react/data-grid";
import Button from "devextreme-react/button";
import { useAuth } from "../../contexts/auth";
import axios from "axios";
import { backendlink } from "../../config";
import { Toast } from "devextreme-react/toast";

export default function CustomerSearchEcgDeviceForm({
  onClose,
  onSelect,
  fetchTrigger,
}) {
  const { user } = useAuth();

  const [loadingSearchButton, setLoadingSearchButton] = useState(false);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const handleSelectionChanged = (e) => {
    setSelectedRowKeys(e.selectedRowKeys);
  };

  const [ecgDeviceList, setEcgDeviceList] = useState([]);

  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "success",
    message: "",
  });

  const onSelectDevice = () => {
    if (selectedRowKeys.length === 0) {
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: "error",
        message: "Please select a row first",
      });
      return;
    }
    onSelect(selectedRowKeys);
    onClose();
    setSelectedRowKeys([]);
  };

  useEffect(() => {
    const onClickSearchButton = async (loadOptions) => {
      try {
        const page = Math.floor(loadOptions.skip / loadOptions.take) + 1;
        const size = loadOptions.take;
        const response = await axios.get(
          backendlink + "customer/getavailablecustecgdevices",
          {
            params: {
              page: page,
              size: size,
              organizationToken: user.userToken,
            },
            headers: {
              token: user.token,
            },
          }
        );

        if (response.data.errorno === 0) {
          const outputArray = response.data.result.map((item) => {
            return {
              deviceId: item.deviceId,
              serialNo: item.serialNo,
              expiryDate: item.expiryDate,
              status: item.status,
            };
          });
          setEcgDeviceList(outputArray);
          setLoadingSearchButton(false);
        } else {
          setEcgDeviceList([]);
          setLoadingSearchButton(false);
        }
      } catch (error) {
        alert(error);
        setLoadingSearchButton(false);
      }
    };

    onClickSearchButton({ skip: 0, take: 5 });
  }, [user, fetchTrigger]);

  function onHiding() {
    setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  }

  return (
    <div>
      <React.Fragment>
        <Form colCount={1} style={{ paddingTop: "20px" }}>
          <GroupItem caption="Device List" iconName="group" colCount={1} />
        </Form>
        <DataGrid
          dataSource={ecgDeviceList}
          selection={{ mode: "single" }}
          selectedRowKeys={selectedRowKeys}
          onSelectionChanged={handleSelectionChanged}
        >
          <Column dataField="serialNo" caption="Device Id" alignment="left" />
          <Column dataField="expiryDate" caption="Expiry Date" />
          <Column dataField="status" caption="Status" />
          <Pager allowedPageSizes={[5, 10, 20]} showPageSizeSelector={true} />
          <Paging defaultPageSize={5} />
          <FilterRow visible={true} />
          <Lookup />
        </DataGrid>

        <Button
          type="default"
          text="Select"
          onClick={(data) => {
            onSelectDevice(data);
          }}
          style={{ width: "100%" }}
          className="full-width-button"
        />
      </React.Fragment>
      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={onHiding}
        displayTime={2000}
      />
    </div>
  );
}